/**
 * Manufacturing API
 * Manufacturing API
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 0 = Unknown, 1 = Online, 2 = Offline
 */
export enum StationStatus {
    Unknown = 0,
    Online = 1,
    Offline = 2
}

